import { FieldErrors, RegisterOptions, UseFormRegister } from 'react-hook-form';
import React from 'react';
import { convertPathToDotNotation } from '@msc-b2c/shared-utils';
import { Text } from '../../text/Text';
import './checkbox.module.scss';
import clsx from 'clsx';

type CheckboxProps = {
  label?: string;
  name: string;
  index: number;
  register: UseFormRegister<any>;
  errors: FieldErrors;
  validation?: RegisterOptions;
  clearErrors: any;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  styleOptions?: string;
  title?: string;
  enableCheckboxTitleAndSubtitle?: boolean;
};

// Checkbox component
export const CheckboxForm = ({
  label,
  name,
  index,
  register,
  errors,
  validation,
  clearErrors,
  disabled,
  onChange,
  checked,
  styleOptions,
  title,
  enableCheckboxTitleAndSubtitle = false,
}: CheckboxProps) => {
  const isError = convertPathToDotNotation(errors, name);
  const errorClass = isError ? 'error-select' : '';

  const { onChange: registerOnChange, ...registerRest } = register(name, { ...validation });

  const renderCheckbox = () => {
    return (
      <input
        className="cmp-form-options__field cmp-form-options__field--checkbox"
        id={`${name}-${index}`}
        type="checkbox"
        {...registerRest}
        onFocus={() => clearErrors(name)}
        disabled={disabled}
        onChange={(e) => {
          registerOnChange(e);
          onChange?.(e);
        }}
        defaultChecked={checked}
      />
    );
  };

  return (
    <div
      className={clsx('options', errorClass, styleOptions, {
        'disabled-select': disabled,
        '-layout-title-and-subtitle': enableCheckboxTitleAndSubtitle,
      })}
    >
      <fieldset className="cmp-form-options cmp-form-options--checkbox">
        {(enableCheckboxTitleAndSubtitle && (
          <>
            {(!!title || !!label) && (
              <label className="cmp-form-options__field-label">
                <div className="cmp-form-options__field--checkbox-container">
                  {renderCheckbox()}
                  <div
                    className={`cmp-form-options__field--checkbox-${
                      title ? 'title' : 'description'
                    }`}
                  >
                    <Text text={title ? title : label} />
                  </div>
                </div>
                {!!label && !!title && (
                  <div className="cmp-form-options__field--checkbox-description">
                    <Text text={label} />
                  </div>
                )}
              </label>
            )}
          </>
        )) || (
          <label className="cmp-form-options__field-label">
            {renderCheckbox()}
            {label && (
              <Text
                styleOption="cmp-form-options__field-description"
                text={label}
                tagHtml="span"
              />
            )}
          </label>
        )}
      </fieldset>
      {isError && (
        <div className="error-list">
          <div className="input-hidden-error-message-vr">
            {convertPathToDotNotation(errors, name)?.message?.toString()}
          </div>
        </div>
      )}
    </div>
  );
};
